import Icon from "@common/controls/Icon/component";
import Input from "@common/controls/Inputs/Text/component";
import withValueHOC from "@common/hocs/withValue";
import { Common } from "@common/types";
import classNames from "classnames";
import * as React from "react";

import "./style.less";

export type SearchProps = Common.InputTypeProps<string> & {
  tourStep?: string;
  autoFocus?: boolean;
  isBusy?: boolean;
  inputClassName?: string;
  placeholder?: string;
  onEnter?: () => void;
  showEnter?: boolean;
};

const SearchBase = ({ className, isBusy, showEnter, placeholder = "Search", ...inputProps }: SearchProps) => (
  <Input
    {...inputProps}
    className={classNames("search_box", className)}
    addon={<Icon className="search_icon" icon={Common.IconType.Search} />}
    placeholder={placeholder}
  />
);

const Search = withValueHOC<string, SearchProps>(React.memo(SearchBase));
export default Search;
